import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { trigger, state, style, transition, animate, group } from '@angular/animations';
import { Store } from '@ngrx/store';
import { ArtifactsBarComponent } from '../artifacts-bar/artifacts-bar.component';

@Component({
  selector: 'app-box-layout',
  standalone: true,
  imports: [CommonModule, ArtifactsBarComponent],
  templateUrl: './box-layout.component.html',
  styleUrls: ['./box-layout.component.scss'],
  animations: [
    trigger('boxState', [
      state(
        'expanded',
        style({
          opacity: 1,
          width: '*',
          flex: '1 1 auto',
          overflow: 'hidden'
        })
      ),
      state(
        'collapsed',
        style({
          width: '0px',
          flex: '0 0 0px',
          padding: '0',
          overflow: 'hidden'
        })
      ),
      transition('expanded => collapsed', [
        group([
          animate('25ms ease-in-out', style({ width: '0px', flex: '0 0 0px', padding: '0' })),
          animate('10ms ease-out', style({ opacity: 0 }))
        ])
      ]),
      transition('collapsed => expanded', [
        style({ display: 'flex', width: '0px', flex: '0 0 0px', opacity: 0 }),
        group([
          animate('25ms ease-in-out', style({ width: '*', flex: '1 1 auto' })),
          animate('10ms 100ms ease-in', style({ opacity: 1 }))
        ])
      ])
    ])
  ]
})
export class BoxLayoutComponent {
  @Input() isContentCollapsed = false;
  @Input() config: { isAppOpened?: boolean } = { isAppOpened: false };

  private readonly store = inject(Store);
}
